import { createClient } from "@supabase/supabase-js";

// الروابط المباشرة لضمان التشغيل الفوري
const supabaseUrl = "https://xdqvkewwfillvfldkotm.supabase.co";
const supabaseAnonKey = "sb_publishable_LHDDZKcdkczLqFXtBluz9Q__rqW60tc";

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase credentials are missing!");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
